module.exports = __webpack_public_path__ + "img/mobile-business.f130f087.png";